<template>
    <div class="question">
        <component :is="questionType" ref="question" :question="question" :showValidation="showValidation" />
        <button v-if="!isLast" v-on:click.stop.prevent="goNext" class="button">Next</button>
        <button v-else class="button is-big is-secondary" type="submit">Submit</button>
    </div>
</template>

<script>
import SurveyQuestionRange from './SurveyQuestionRange'
import SurveyQuestionRatedMultiple from './SurveyQuestionRatedMultiple'

export default {
    name: 'SurveyQuestion',
    components: {
        SurveyQuestionRange,
        SurveyQuestionRatedMultiple
    },
    props: [
        'question',
        'isLast'
    ],
    data: function () {
        return {
            showValidation: false
        }
    },
    computed: {
        questionType () {
            switch (this.question && this.question.type) {
            case 'ratedMultiple':
                return 'SurveyQuestionRatedMultiple'
            case 'range':
                return 'SurveyQuestionRange'
            }
        }
    },
    methods: {
        goNext () {
            if (this.$refs.question.isValid) {
                this.showValidation = false;
                this.$emit('goNext');
            } else {
                this.showValidation = true;
            }
            
        }
    }
}
</script>

<style lang="scss">
.question {
    text-align: right;
    padding: 1em;

    @media (min-width: 760px) {
        width: 500px;
        border: 1px solid;
        margin: 0 auto;
    }
}
</style>
